import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'
import {MainContainer} from '../../theme/mainContainer.styled'

export const Container = styled.div``

export const StyledBlockPresentation = styled(MainContainer)`
  display: flex;
  margin: ${pxToRem(40)} auto 0;

  @media ${deviceMax.tablet} {
    flex-direction: column;
  }
`